import React from 'react'
import BranchImg1 from '../../Images/BranchesImg/Branch3.png'
import BranchPerson from '../../Images/HR/OtherSubCommittee/MamataKhatiwada.jpg'
import BranchImg2 from '../../Images/HR/BODMember/BhaktiPrasadDhakal.jpg'
import BranchImg3 from '../../Images/BranchesImg/Branches3/BidurSubediSahasamyojak.jpg'
import BranchImg4 from '../../Images/BranchesImg/Branches3/BalKumarKalakheti.jpg'
import BranchImg5 from '../../Images/BranchesImg/Branches3/BhupindraPrasadDhakal.jpg'
import BranchImg6 from '../../Images/BranchesImg/Branches3/HimaPokhrel.jpg'
import Aos from 'aos'

const Branch3 = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    const BranchMemberList = [
        {
            id: '1',
            memName: 'भक्तिप्रसाद ढकाल',
            post: 'संयोजक',
            memImg: BranchImg2
        },
        {
            id: '2',
            memName: 'वीदुर सुवेदी',
            post: 'सह संयोजक',
            memImg: BranchImg3
        },
        {
            id: '3',
            memName: 'बालकुमार कालाखेती',
            post: 'सदस्य',
            memImg: BranchImg4
        },
        {
            id: '4',
            memName: 'भुपिन्द्रप्रसाद ढकाल',
            post: 'सदस्य',
            memImg: BranchImg5
        },
        {
            id: '5',
            memName: 'हिमा पोख्रेल',
            post: 'सदस्य',
            memImg: BranchImg6
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='branch-section'>
                        <div className='branch-section-left' data-aos='fade-right'>
                            <img src={BranchImg1} alt='Branch1' />
                        </div>
                        <div className='branch-section-right' data-aos='fade-right'>
                            <div className='card-section'>
                                <div className='card-section-title'>
                                    <h2>विराटचोक सेवाकेन्द्र</h2>
                                </div>
                                <div className='card-section-img'>
                                    <img src={BranchPerson} alt='card-img' />
                                    <h3>ममता खतिवडा</h3>
                                    <h4>सेवाकेन्द्र प्रमुख</h4>
                                </div>
                                <div className='card-section-detail'>
                                    <h3><i className='bi bi-telephone-fill' />०२१-५४८९०९</h3>
                                    <h3><i className='bi bi-envelope-fill' />klsbiratchock2077@gmail.com</h3>
                                    <h3><i className='bi bi-geo-alt-fill' />सुन्दरहरैचा–९, मोरङ</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='branch-section-bottom'>
                        <div className='branches-top'>
                            <div className='welcome-title-center1' data-aos='fade-right'>
                                <h2 style={{ color: 'rgb(0, 166, 80)' }}>सेवाकेन्द्र व्यवस्थापन उपसमिति, विराटचोक सेवाकेन्द्र</h2>
                            </div>
                        </div>
                        {/* <div className='welcome-center' data-aos='fade-right'>
                            <h3>Branch Management Sub-Committee</h3>
                        </div> */}
                        <div className='president2'>
                            {BranchMemberList.map((item, index) => {
                                return (
                                    <div className='president2-body' key={index} data-aos='fade-right'>
                                        <div className='president2-img'>
                                            <img src={item.memImg} alt='AdvisoryBoard' />
                                        </div>
                                        <div className='president2-detail'>
                                            <h2>{item.memName}</h2>
                                            <h3>{item.post}</h3>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Branch3